'use client';

import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { EsiteContext } from './types';

const esiteContext = createContext<EsiteContext>({
  catalogId: '',
  dealerCode: '',
  esiteIdentifier: '',
  lang: '',
  langId: '',
  locale: '',
  storeId: '',
  userCountryCode: '',
  userCity: '',
  userRegionCode: ''
});

export const useEsiteCtx = () => useContext(esiteContext);

export const EsiteProvider: FC<PropsWithChildren<{ value: EsiteContext }>> = ({
  children,
  value
}) => <esiteContext.Provider value={value}>{children}</esiteContext.Provider>;
